export default {
  body: 1.75,
  heading: 1.125
}
